module.exports = __webpack_public_path__ + "img/151.ede83fe6.png";